import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  MenuItem,
  Menu,
  Container,
  Button,
  Collapse,
  List,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import MRunsLogo from './MRunsLogo';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Updated sections structure
const sections = [
  { title: 'Home', url: '/' },
  { title: 'Blog', url: '/blog' },
  { title: 'Photos', url: '/photos' },
  {
    title: 'Media',
    subItems: [
      { title: 'Podcast', url: '/podcast' },
      { title: 'YouTube', url: '/community' }, // Renamed from Community
    ],
  },
  {
    title: 'Tools',
    subItems: [
      { title: 'Pace Calculator', url: '/pace-calculator' },
      { title: 'Training Plan Generator', url: '/training' },
    ],
  },
];

export default function NavBar() {
  const [mobileMenuAnchorEl, setMobileMenuAnchorEl] = useState(null);
  const [toolsMenuAnchorEl, setToolsMenuAnchorEl] = useState(null);
  const [mediaMenuAnchorEl, setMediaMenuAnchorEl] = useState(null); // New state for Media menu
  const [openMobileSubMenu, setOpenMobileSubMenu] = useState({ tools: false, media: false });

  const handleMobileMenuOpen = (event) => setMobileMenuAnchorEl(event.currentTarget);
  const handleMobileMenuClose = () => {
    setMobileMenuAnchorEl(null);
    setOpenMobileSubMenu({ tools: false, media: false });
  };

  const handleMenuOpen = (event, menu) => {
    if (menu === 'tools') setToolsMenuAnchorEl(event.currentTarget);
    if (menu === 'media') setMediaMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setToolsMenuAnchorEl(null);
    setMediaMenuAnchorEl(null);
  };

  const handleMobileSubMenuToggle = (menu) => {
    setOpenMobileSubMenu(prev => ({ ...prev, [menu]: !prev[menu] }));
  };

  return (
    <AppBar position="static" color="transparent" elevation={0} sx={{ py: 1 }}>
      <Container maxWidth="lg">
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <IconButton component={Link} to="/" sx={{ p: 0, mr: 2 }}>
            <MRunsLogo />
          </IconButton>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center' }}> {/* Centering items */}
            {sections.map((section) =>
              section.subItems ? (
                <Box key={section.title}>
                  <Button
                    onClick={(e) => handleMenuOpen(e, section.title.toLowerCase())}
                    onMouseOver={(e) => handleMenuOpen(e, section.title.toLowerCase())}
                    endIcon={<ArrowDropDownIcon />}
                    sx={{ color: 'text.secondary', textTransform: 'none', fontSize: '1rem' }}
                  >
                    {section.title}
                  </Button>
                  <Menu
                    anchorEl={section.title === 'Tools' ? toolsMenuAnchorEl : mediaMenuAnchorEl}
                    open={Boolean(section.title === 'Tools' ? toolsMenuAnchorEl : mediaMenuAnchorEl)}
                    onClose={handleMenuClose}
                    MenuListProps={{ onMouseLeave: handleMenuClose }}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    {section.subItems.map((item) => (
                      <MenuItem key={item.title} component={Link} to={item.url} onClick={handleMenuClose}>
                        {item.title}
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              ) : (
                <Typography
                  key={section.title}
                  component={Link}
                  to={section.url}
                  sx={{ mx: 2, color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'text.primary' } }}
                >
                  {section.title}
                </Typography>
              )
            )}
          </Box>

          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton onClick={handleMobileMenuOpen} color="inherit" aria-label="open menu">
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={mobileMenuAnchorEl}
              open={Boolean(mobileMenuAnchorEl)}
              onClose={handleMobileMenuClose}
            >
              {sections.map((section) =>
                section.subItems ? (
                  <div key={section.title}>
                    <MenuItem onClick={() => handleMobileSubMenuToggle(section.title.toLowerCase())}>
                      <ListItemText primary={section.title} />
                      <ArrowDropDownIcon />
                    </MenuItem>
                    <Collapse in={openMobileSubMenu[section.title.toLowerCase()]} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {section.subItems.map((item) => (
                          <MenuItem
                            key={item.title}
                            component={Link}
                            to={item.url}
                            onClick={handleMobileMenuClose}
                            sx={{ pl: 4 }}
                          >
                            <ListItemText primary={item.title} />
                          </MenuItem>
                        ))}
                      </List>
                    </Collapse>
                  </div>
                ) : (
                  <MenuItem key={section.title} component={Link} to={section.url} onClick={handleMobileMenuClose}>
                    <ListItemText primary={section.title} />
                  </MenuItem>
                )
              )}
            </Menu>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, minWidth: '80px' }} />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
